'use client'

import Link from 'next/link'
import React, { useEffect, useRef, useState } from 'react'
import { filterService } from '@services/driveFilterService'
import { ApiFilterResponse } from '@interfaces/ackoDrive'
import { Button } from '@components/Ackodrive/Button'
import { usePathname } from 'next/navigation'
import styles from './HeaderNav.module.scss'
import { headerNavData } from './HeaderNav.data'
import HeaderNavModal from '../headerNavModal'

const HeaderNav = () => {
  const [modalState, setModalState] = useState<{
    isOpen: boolean
    type: 'blog' | 'buyCar' | null
    position: number
  }>({
    isOpen: false,
    type: null,
    position: 0,
  })

  const [filterData, setFilterData] = useState<ApiFilterResponse | null>(null)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const isMouseOverHeaderNavModalRef = useRef(false)
  const isMouseOverNewCarNavModalRef = useRef(false)
  const pathname = usePathname()

  useEffect(() => {
    const fetchFilterData = async () => {
      try {
        const data = await filterService.getFilters()
        setFilterData(data)
      } catch (error) {
        console.error('Error fetching filter data in HeaderNav:', error)
        setFilterData(null)
      }
    }

    void fetchFilterData()
  }, [])

  useEffect(() => {
    setModalState({
      isOpen: false,
      type: null,
      position: 0,
    })
    clearTimeoutRef()
  }, [pathname])

  useEffect(
    () => () => {
      clearTimeoutRef()
    },
    []
  )

  const clearTimeoutRef = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }

  const closeModal = () => {
    setModalState({
      isOpen: false,
      type: null,
      position: 0,
    })
    clearTimeoutRef()
  }

  const handleMouseEnter = (type: 'blog' | 'buyCar', event: React.MouseEvent<HTMLElement>) => {
    clearTimeoutRef()
    setModalState({
      isOpen: true,
      type,
      position: event.currentTarget.getBoundingClientRect().left,
    })
  }

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      console.log(isMouseOverHeaderNavModalRef.current)
      console.log(isMouseOverNewCarNavModalRef.current)
      if (!isMouseOverHeaderNavModalRef.current && !isMouseOverNewCarNavModalRef.current) {
        closeModal()
      }
    }, 300)
  }

  const onHeaderNavModalHover = (isHovering: boolean) => {
    isMouseOverHeaderNavModalRef.current = isHovering
    if (isHovering) {
      clearTimeoutRef()
    } else {
      handleMouseLeave()
    }
  }

  const onNewCarNavModalHover = (isHovering: boolean) => {
    isMouseOverNewCarNavModalRef.current = isHovering
    if (isHovering) {
      clearTimeoutRef()
    } else if (!isMouseOverHeaderNavModalRef.current) {
      handleMouseLeave()
    }
  }

  return (
    <div className={styles.navContainer}>
      <Link href="https://ackodrive.com/garage-storefront/service-centre" className={styles.navLink}>
        Service car
      </Link>

      <Button
        className={styles.navLink}
        onMouseEnter={e => handleMouseEnter('buyCar', e)}
        onMouseLeave={handleMouseLeave}>
        Buy car
      </Button>

      <Link href="https://ackodrive.com/used/car-exchange/" className={styles.navLink}>
        Exchange car
      </Link>

      <Button
        className={styles.navLink}
        onMouseEnter={e => handleMouseEnter('blog', e)}
        onMouseLeave={handleMouseLeave}>
        News
      </Button>

      {modalState.isOpen && (modalState.type === 'buyCar' || modalState.type === 'blog') && (
        <HeaderNavModal
          headerNavData={headerNavData}
          onClose={closeModal}
          type={modalState.type}
          position={modalState.position}
          onMouseEnter={() => onHeaderNavModalHover(true)}
          onMouseLeave={() => onHeaderNavModalHover(false)}
          onNewCarNavModalHover={onNewCarNavModalHover}
          filterData={filterData}
        />
      )}
    </div>
  )
}

export default HeaderNav
